import { useCallback } from 'preact/hooks';

import { type ErrorData } from '@/app/types/yandex';

import { type UseAdvertisementProps } from './types';
import { useMoneyTagAds } from './use-moneytag-ads';

/**
 * Адаптер для согласования типов MoneyTag рекламы с нашей системой рекламы
 */
export const useMoneyTagAdapter = ({
  onReward,
  onError,
  onSkip,
}: UseAdvertisementProps = {}) => {
  const { show: showMoneyTagAds, showBanner: showMoneyTagBanner } = useMoneyTagAds({
    onReward,
    onError: (err: ErrorData | Error) =>
      onError?.(err instanceof Error ? err : new Error(err.text || 'Unknown error')),
    onSkip,
  });

  // Обертка для совместимости с API useAdvertisement
  const moneyTagAdapter = useCallback(() => {
    showMoneyTagAds();
  }, [showMoneyTagAds]);

  const moneyTagBannerAdapter = useCallback(
    (config?: {
      frequency?: number;
      capping?: number;
      interval?: number;
      timeout?: number;
      everyPage?: boolean;
    }) => {
      showMoneyTagBanner(config);
    },
    [showMoneyTagBanner]
  );

  return { show: moneyTagAdapter, showBanner: moneyTagBannerAdapter };
};
